"use strict";import{Swatch as e}from"./src/Swatch.js";import{defineElement as a}from"@spectrum-web-components/base/src/define-element.js";a("sp-swatch",e);
//# sourceMappingURL=sp-swatch.js.map
